import React, { useState } from 'react';
import styles from './Dialog.module.css';

export default function CalibrationDialog({ points, pxDist, onConfirm, onCancel }) {
  const [mm, setMm] = useState('25');
  const valid = Number.isFinite(Number(mm)) && Number(mm) > 0 && pxDist > 0;

  return (
    <div className={styles.backdrop}>
      <div className={styles.panel}>
        <div className={styles.title}>Calibrate</div>
        <div className={styles.body}>
          <div className={styles.meta}>
            Pixel distance between your two clicks: <strong>{pxDist.toFixed(1)} px</strong>
          </div>
          <label className={styles.label}>Known real-world length (mm)</label>
          <input
            className={styles.input}
            type="number"
            step="0.1"
            autoFocus
            value={mm}
            onChange={(e) => setMm(e.target.value)}
            placeholder="25.0"
          />
          <div className={styles.hint}>
            Tip: use a 25 mm calibration ball in the field of view, or enter a
            known anatomical landmark distance (e.g. femoral head ≈ 50 mm).
          </div>
        </div>
        <div className={styles.actions}>
          <button className={styles.btnGhost} onClick={onCancel}>Cancel</button>
          <button
            className={styles.btnPrimary}
            disabled={!valid}
            onClick={() => onConfirm({ points, mm: Number(mm), pxDist, mmPerPx: Number(mm) / pxDist })}
          >
            Apply calibration
          </button>
        </div>
      </div>
    </div>
  );
}
